import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";

const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const LocationForm = () => {
  const {
    control,
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();
  return (
    <div className="form-row row">
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="locationCode"
          type="text"
          placeholder="Location Code"
          className={`form-control ${errors.locationCode ? "is-invalid" : ""}`}
          label="Location Code"
          labelClassName="form-label"
          required={true}
          requiredMessage="Location Code is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="locationName"
          type="text"
          placeholder="Location Name"
          className={`form-control ${errors.locationName ? "is-invalid" : ""}`}
          label="Location Name"
          labelClassName="form-label"
          required={true}
          requiredMessage="Location Name is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="address1"
          type="text"
          placeholder="Address1"
          className={`form-control ${errors.address1 ? "is-invalid" : ""}`}
          label="Address1"
          labelClassName="form-label"
          required={true}
          requiredMessage="address1 is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="address2"
          type="text"
          placeholder="Address2"
          className={`form-control ${errors.address2 ? "is-invalid" : ""}`}
          label="Address2"
          labelClassName="form-label"
          required={false}
          requiredMessage="address2 is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="address3"
          type="text"
          placeholder="Address3"
          className={`form-control ${errors.address3 ? "is-invalid" : ""}`}
          label="Address3"
          labelClassName="form-label"
          required={false}
          requiredMessage="address3 is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="country"
          type="text"
          placeholder="Country"
          className={`form-control ${errors.country ? "is-invalid" : ""}`}
          label="Country"
          labelClassName="form-label"
          required={true}
          requiredMessage="Country is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="zipCode"
          type="number"
          placeholder="Zip Code"
          className={`form-control ${errors.zipCode ? "is-invalid" : ""}`}
          label="Zip Code"
          labelClassName="form-label"
          required={true}
          requiredMessage="Zip Code is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isActive"
          type="commonSelect"
          placeholder="Select Status"
          className={`form-control select ${errors.isActive ? "is-invalid" : ""}`}
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div>
    </div>
  );
};

export default LocationForm;
